import type { Router } from "vue-router";
import { EventType, type AuthenticationResult, type PublicClientApplication } from "@azure/msal-browser";
import { InternalNavigationClient } from "@/authentication/InternalNavigationClient";

export function setupAuthentication(msalInstance: PublicClientApplication, router: Router) {
  const navigationClient = new InternalNavigationClient(router);
  msalInstance.setNavigationClient(navigationClient);

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      router.push({ path: "/" });
    }
  });
}
